import React from "react";

const getMandatoryEnv = require("../../../sites-common/utils/getMandatoryEnv");

const { contributionsLink } = getMandatoryEnv(["contributionsLink"]);

// This JSON contains the paths that need to be redirected to the contributions application.
// The paths are defined in the format { fromPath: "path/from/to/redirect", toPath: "path/to/redirect/" }
// The `fromPath` is the path that will be matched against the current URL,
// and the `toPath` is the URL to which the user will be redirected.
export const EXTERNAL_REDIRECTS = [
  {
    fromPath: "green-kanha",
    toPath: `${contributionsLink}/in-en/green-kanha`,
  },
  {
    fromPath: "heartfulness-green",
    toPath: `${contributionsLink}/in-en/heartfulness-green`,
  },
  {
    fromPath: "yoga-donations",
    toPath: `${contributionsLink}/in-en/yoga-donations`,
  },
  {
    fromPath: "donation-general-fund",
    toPath: `${contributionsLink}/in-en/donation-general-fund`,
  },
  {
    fromPath: "donation-corpus-fund",
    toPath: `${contributionsLink}/in-en/donation-general-fund`,
  },
  {
    fromPath: "heartfulness-experience-lifes-potential-help",
    toPath: `${contributionsLink}/in-en/kanha-educare-activity-center`,
  },
  {
    fromPath: "smsf-india-corpus-fund-offline",
    toPath: `${contributionsLink}/in-en/donation-general-fund`,
  },
  {
    fromPath: "donation-for-smsf-india-every-drop-counts",
    toPath: `${contributionsLink}/in-en/donation-for-smsf-india-every-drop-counts`,
  },
  {
    fromPath: "recurring-donation-heartfulness-institute",
    toPath: `${contributionsLink}/in-en/recurring-donation-heartfulness-institute`,
  },
  {
    fromPath: "donation-for-smsf-india-general-fund-offline",
    toPath: `${contributionsLink}/in-en/donation-general-fund`,
  },
  {
    fromPath: "donation-for-smsf-india-general-fund-offline",
    toPath: `${contributionsLink}/in-en/donation-general-fund`,
  },
  {
    fromPath: "donation-for-smsf-india-every-drop-counts-offline",
    toPath: `${contributionsLink}/in-en/donation-for-smsf-india-every-drop-counts`,
  },

  {
    fromPath: "general-donation-to-srcm-usa",
    toPath: `${contributionsLink}/us/general-donation-to-srcm-usa?mode=onetime`,
  },
  {
    fromPath: "general-donation-to-smsf-usa",
    toPath: `${contributionsLink}/us/general-donation-to-smsf-usa?mode=onetime`,
  },
  {
    fromPath: "heartfulness-institute-donation-usa",
    toPath: `${contributionsLink}/us/heartfulness-institute-donation-usa?mode=onetime`,
  },

  {
    fromPath: "general-donations-to-heartfulness-institute-usa-recurring",
    toPath: `${contributionsLink}/us/heartfulness-institute-donation-usa`,
  },
  {
    fromPath: "recurring-general-donation-to-srcm-usa",
    toPath: `${contributionsLink}/us/general-donation-to-srcm-usa`,
  },
  {
    fromPath: "recurring-general-donation-smsf-usa",
    toPath: `${contributionsLink}/us/general-donation-to-smsf-usa`,
  },

  {
    fromPath: "general-donations-to-heartfulness-institute-usa-offline",
    toPath: `${contributionsLink}/us/heartfulness-institute-donation-usa`,
  },
  {
    fromPath: "general-donation-to-srcm-usa-offline",
    toPath: `${contributionsLink}/us/general-donation-to-srcm-usa`,
  },
  {
    fromPath: "general-donation-to-smsf-usa-offline",
    toPath: `${contributionsLink}/us/general-donation-to-smsf-usa`,
  },
  {
    fromPath: "dollar-a-day-usa",
    toPath: `${contributionsLink}/us/dollar-a-day-campaign`,
  },
];

// Function to handle redirection based on the current path.
export const redirectToContributions = () => {
  const path = window.location.pathname.replace(/^\//, "").replace(/\/$/, "");
  const redirect = EXTERNAL_REDIRECTS.find(
    (_redirect) => _redirect.fromPath === path
  );
  if (redirect) {
    if (typeof window !== "undefined") {
      window.location.href = redirect.toPath;
      return <h4>Redirecting...</h4>;
    }
  }
  return null;
};

// Function to check if the current window is a WebView.
export const isWebView = () => {
  if (typeof window === "undefined") return false;

  const { userAgent } = navigator;

  // Check for specific WebView indicators (more precise)
  return (
    // Android WebView - look for 'wv' specifically
    /Android.*wv\)/i.test(userAgent) ||
    // iOS WebView - has iPhone/iPad but missing Safari
    (/iPhone|iPad/i.test(userAgent) && !/Safari/i.test(userAgent)) ||
    // React Native WebView
    /ReactNative/i.test(userAgent) ||
    // Flutter WebView
    /Flutter/i.test(userAgent) ||
    // Explicit WebView identifier
    /WebView/i.test(userAgent) ||
    // Check for app-specific bridges (most reliable)
    !!(window.ReactNativeWebView || window.flutter_inappwebview)
  );
};
